import { getTrans } from '@/services/global/translations.interface';
import tectoastr from '@/lib/tectoastr';
import { ArrayOrItem, EventInfo, Plugin } from 'ckeditor5';

declare module '@ckeditor/ckeditor5-core' {
	// eslint-disable-next-line no-unused-vars
	interface PluginsMap {
		[InsertImageBlockInvalidUrls.pluginName]: InsertImageBlockInvalidUrls;
	}
}

class InsertImageBlockInvalidUrls extends Plugin {
	static get requires() {
		return ['ImageInsertViaUrl'];
	}

	public static get pluginName() {
		return 'InsertImageBlockInvalidUrls ' as const;
	}

	// in order for insertImage command to be registered
	public afterInit() {
		const { editor } = this;
		const commands = ['insertImage'];

		commands.forEach((name) => {
			const cmd = editor.commands.get(name);

			if (!cmd) return;

			this.listenTo(
				cmd,
				'execute',
				this.handler.bind(this),
				{ priority: 'highest' } // in order to stop the command execution as soon as possible
			);
		});
	}

	handler(evt: EventInfo<string, unknown>, [options]: [{ source: ArrayOrItem<string | Record<string, unknown>> }]) {
		const sources = Array.isArray(options.source) ? options.source : [options.source];

		sources.forEach((source) => {
			if (this.sourceIsAllowed(source)) return;

			evt.stop(); // cancel the command
			tectoastr.error(getTrans().get('editor.image_url_is_not_valid'));
		});
	}

	sourceIsAllowed(source: ArrayOrItem<string | Record<string, unknown>>) {
		// return early in case the source received is Record<string, unknown>
		if (typeof source !== 'string' || !source) return;

		const trimmedSource = source.trim();

		if (trimmedSource.startsWith('data:')) return false;

		try {
			const parsed = new URL(trimmedSource);
			return parsed.protocol === 'https:' || parsed.protocol === 'http:';
		} catch {
			return false;
		}
	}
}

export default InsertImageBlockInvalidUrls;
